(function () {
  function initCarousel(root) {
    if (root.dataset.cfBound === 'true') return;
    var track = root.querySelector('.trk');
    var slides = root.querySelectorAll('.sl');
    var dots = root.querySelectorAll('.dots button');
    var cap = root.querySelector('.cap');
    var prev = root.querySelector('.pv');
    var next = root.querySelector('.nx');
    if (!track || !slides.length) return;
    root.dataset.cfBound = 'true';
    var index = 0;
    var timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (dot, dotIndex) {
        if (dotIndex === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      slides.forEach(function (slide, slideIndex) {
        slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
      });
      if (cap) cap.innerHTML = slides[index].dataset.cap || '';
      var frameNow = root.querySelector('.imac');
      if (frameNow) {
        frameNow.classList.toggle('imac--monitor', slides[index].dataset.monitor === 'true');
      }
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function play() {
      stop();
      if (!reduce && slides.length > 1) {
        timer = setInterval(function () {
          go(index + 1);
        }, 5000);
      }
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); play(); });
    if (next) next.addEventListener('click', function () { go(index + 1); play(); });
    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () { go(dotIndex); play(); });
    });

    var frame = root.querySelector('.imac');
    if (frame) {
      frame.addEventListener('mouseenter', stop);
      frame.addEventListener('mouseleave', play);
    }
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) play();
    });

    var startX = null;
    var viewport = root.querySelector('.vp');
    if (viewport) {
      viewport.addEventListener('touchstart', function (event) {
        startX = event.touches[0].clientX;
        stop();
      }, { passive: true });
      viewport.addEventListener('touchend', function (event) {
        if (startX === null) return;
        var delta = event.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 40) go(index + (delta < 0 ? 1 : -1));
        startX = null;
        play();
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else play();
    });

    go(0);
    play();
  }

  function initFaq(root) {
    if (root.dataset.cfBound === 'true') return;
    root.dataset.cfBound = 'true';
    root.querySelectorAll('details').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        root.querySelectorAll('details').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function submitCart(form) {
    if (!form) return;
    if (typeof form.submit === 'function') form.submit();
  }

  function formatPence(pence, format) {
    var safe = Math.max(0, Math.round(Number(pence) || 0));
    var amount = (safe / 100).toFixed(2);
    var parts = amount.split('.');
    var grouped = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var noDecimals = String(Math.round(safe / 100));
    var pattern = format || '£{{amount}}';
    return pattern
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, grouped)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'") + '.' + parts[1])
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function syncCartSummary(form) {
    if (!form) return;
    var summary = form.querySelector('[data-cf-order-summary]');
    if (!summary) return;
    var rate = Number(summary.getAttribute('data-vat-rate') || 20);
    var taxesIncluded = summary.getAttribute('data-taxes-included') === 'true';
    var moneyFormat = summary.getAttribute('data-money-format') || '£{{amount}}';
    var row = form.querySelector('[data-cf-delivery-row]');
    var threshold = row ? Number(row.getAttribute('data-threshold') || 0) : 0;
    var express = row ? Number(row.getAttribute('data-express') || 0) : 0;
    var goods = 0;
    form.querySelectorAll('[data-cf-unit]').forEach(function (line) {
      var unit = Number(line.getAttribute('data-cf-unit') || 0);
      var input = line.querySelector('[data-cf-qty-input]');
      var qty = input ? Number(input.value || 0) : 0;
      if (qty < 0) qty = 0;
      var linePence = unit * qty;
      goods += linePence;
      var lineTotal = line.querySelector('.klt span');
      if (lineTotal) lineTotal.textContent = formatPence(linePence, moneyFormat);
    });

    var net = goods;
    var goodsVat = Math.floor((goods * rate) / 100);
    if (taxesIncluded) {
      net = Math.floor((goods * 100) / (100 + rate));
      goodsVat = goods - net;
    }
    var deliveryNet = net >= threshold ? 0 : express;
    var deliveryVat = Math.floor((deliveryNet * rate) / 100);
    var vat = goodsVat + deliveryVat;
    var total = net + vat + deliveryNet;
    var gap = Math.max(0, threshold - net);

    function paint(selector, pence) {
      var node = summary.querySelector(selector);
      if (!node) return;
      node.textContent = formatPence(pence, moneyFormat);
      node.setAttribute('data-pence', String(pence));
    }
    paint('[data-cf-subtotal]', net);
    paint('[data-cf-vat]', vat);
    paint('[data-cf-total]', total);

    var price = form.querySelector('[data-cf-delivery-price]');
    if (price) {
      price.textContent = deliveryNet === 0 ? 'Free' : formatPence(deliveryNet, moneyFormat);
      price.setAttribute('data-pence', String(deliveryNet));
    }
    var note = form.querySelector('[data-cf-delivery-note]');
    if (deliveryNet === 0) {
      if (note) note.remove();
    } else {
      var noteText = 'Spend ' + formatPence(gap, moneyFormat) + ' more for free Express delivery';
      if (!note && row) {
        note = document.createElement('p');
        note.className = 'kship';
        note.setAttribute('data-cf-delivery-note', '');
        row.insertAdjacentElement('afterend', note);
      }
      if (note) note.textContent = noteText;
    }
  }

  function initQty(root) {
    root.querySelectorAll('[data-cf-qty]').forEach(function (button) {
      if (button.dataset.cfBound === 'true') return;
      button.dataset.cfBound = 'true';
      button.addEventListener('click', function () {
        var wrap = button.parentElement;
        if (!wrap) return;
        var input = wrap.querySelector('input');
        if (!input) return;
        var delta = Number(button.getAttribute('data-cf-qty') || 0);
        var min = Number(input.min || 0);
        var max = Number(input.max || 99);
        var current = Number(input.value || min);
        var next = Math.min(max, Math.max(min, current + delta));
        if (next < 1) next = 0;
        input.value = String(next);
        var form = button.closest('form');
        syncCartSummary(form);
        submitCart(form);
      });
    });
    root.querySelectorAll('[data-cf-qty-input]').forEach(function (input) {
      if (input.dataset.cfBound === 'true') return;
      input.dataset.cfBound = 'true';
      input.addEventListener('change', function () {
        var form = input.closest('form');
        syncCartSummary(form);
        submitCart(form);
      });
    });
  }

  function bindAdd(root) {
    root.querySelectorAll('[data-cf-add]').forEach(function (button) {
      if (button.dataset.cfBound === 'true') return;
      button.dataset.cfBound = 'true';
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-variant-id');
        var endpoint = button.getAttribute('data-add-url') || '/cart/add.js';
        if (!id) return;
        button.disabled = true;
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('add failed');
            window.location.assign('/cart');
          })
          .catch(function () {
            button.disabled = false;
          });
      });
    });
  }

  function initUpsell(root) {
    var slot = root.querySelector('[data-cf-upsell-slot]');
    if (!slot || slot.dataset.cfBound === 'true') return;
    var url = slot.getAttribute('data-url');
    if (!url) {
      slot.remove();
      return;
    }
    slot.dataset.cfBound = 'true';
    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('[data-cf-upsell-card]');
        if (!card) {
          slot.remove();
          return;
        }
        slot.replaceWith(card);
        bindAdd(document);
      })
      .catch(function () {
        slot.remove();
      });
  }

  function initQuotes(root) {
    if (root.dataset.cfBound === 'true') return;
    var track = root.querySelector('.cft-trk');
    var slides = root.querySelectorAll('.cft-sl');
    var dots = root.querySelectorAll('.cft-dots button');
    var prev = root.querySelector('[data-cf-prev]');
    var next = root.querySelector('[data-cf-next]');
    if (!track || !slides.length) return;
    root.dataset.cfBound = 'true';
    var index = 0;
    var timer = null;
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function motionOff() {
      return motion.matches || (window.Shopify && window.Shopify.designMode);
    }

    function announce(slide) {
      var live = root.querySelector('[data-cf-live]');
      if (!live) return;
      var quote = slide.querySelector('.cft-q');
      var name = slide.querySelector('.cft-name');
      var text = quote ? quote.textContent.trim() : '';
      if (name && name.textContent.trim()) text += ' ' + name.textContent.trim();
      if (live.textContent.trim() !== text) live.textContent = text;
    }

    function go(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (dot, dotIndex) {
        if (dotIndex === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      slides.forEach(function (slide, slideIndex) {
        if (slideIndex === index) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      announce(slides[index]);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function play() {
      stop();
      if (!motionOff() && slides.length > 1) {
        timer = setInterval(function () {
          go(index + 1);
        }, 7000);
      }
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); play(); });
    if (next) next.addEventListener('click', function () { go(index + 1); play(); });
    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () { go(dotIndex); play(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) play();
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(index - 1);
        play();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(index + 1);
        play();
      }
    });

    var startX = null;
    var viewport = root.querySelector('.cft-vp');
    if (viewport) {
      viewport.addEventListener('touchstart', function (event) {
        startX = event.touches[0].clientX;
        stop();
      }, { passive: true });
      viewport.addEventListener('touchend', function (event) {
        if (startX === null) return;
        var delta = event.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 40) go(index + (delta < 0 ? 1 : -1));
        startX = null;
        play();
      });
    }

    if (typeof motion.addEventListener === 'function') {
      motion.addEventListener('change', function () {
        if (motionOff()) stop();
        else play();
      });
    }

    root.addEventListener('shopify:block:select', function (event) {
      var slide = event.target && event.target.closest ? event.target.closest('.cft-sl') : null;
      if (!slide || !root.contains(slide)) return;
      var chosen = Array.prototype.indexOf.call(slides, slide);
      if (chosen < 0) return;
      stop();
      go(chosen);
    });

    go(0);
    play();
  }

  function scan(scope) {
    var root = scope || document;
    root.querySelectorAll('.wsc').forEach(initCarousel);
    root.querySelectorAll('[data-cf-quotes]').forEach(initQuotes);
    root.querySelectorAll('[data-cf-faq]').forEach(initFaq);
    initQty(root);
    initUpsell(root);
    bindAdd(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
